import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import LoadingWrapper from 'dpl/components/LoadingWrapper';
import { setPrismicDocumentUid } from 'dpl/actions/server';

import usePrismicDocument from '../hooks/usePrismicDocument';
import { DOCUMENT_TYPE_TO_COMPONENT } from '../utils/documentTypeToComponent';

export default function Preview() {
  const prismicDocumentUid = useSelector(
    ({ server }) => server.prismicDocumentUid
  );
  const { uid, type } = usePrismicDocument();
  const dispatch = useDispatch();

  useEffect(() => {
    if (uid) {
      dispatch(setPrismicDocumentUid(uid));
    }
  }, [uid]);

  const Component = DOCUMENT_TYPE_TO_COMPONENT[type];

  if (!Component) {
    return null;
  }

  return (
    <div className="PrismicPreview">
      <LoadingWrapper
        isLoading={!prismicDocumentUid}
        className="fixed absolute--fill"
      >
        <Component />
      </LoadingWrapper>
    </div>
  );
}
